import { Component, OnInit } from '@angular/core';
import { AgencyContactDetails } from '@app/models/';

import { AsyncPipe, NgStyle } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatIconButton } from '@angular/material/button';
import { MatCard, MatCardContent, MatCardHeader, MatCardTitle } from '@angular/material/card';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatInput, MatLabel, MatSuffix } from '@angular/material/input';
import { MatTooltip } from '@angular/material/tooltip';
import { AgencyService, QbService, ToastService } from '@app/services';
import { AuthService } from '@auth0/auth0-angular';
import { Observable, take } from 'rxjs';
import { debounce } from 'src/assets/helpers/debounce';

@Component({
  selector: 'qb-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
  imports: [
    FormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    AsyncPipe,
    MatCard,
    MatCardContent,
    MatCardHeader,
    MatCardTitle,
    MatDivider,
    NgStyle,
    MatIcon,
    MatTooltip,
    MatIconButton,
    MatSuffix,
  ],
})
export class ContactComponent implements OnInit {
  isAuthenticated$: Observable<boolean> = this.auth.isAuthenticated$;

  agenciesList: AgencyContactDetails[] = [];
  searchQuery = '';

  debouncedGetAgencies = debounce(this.getAgencies, 100, false);

  constructor(
    private qb: QbService,
    private auth: AuthService,
    private agencyService: AgencyService,
    private toast: ToastService
  ) {}

  ngOnInit(): void {
    this.qb.loading = true;
    this.getAgencies();
  }

  getAgencies(query = '') {
    this.agencyService
      .getAgencyContactDetails(query)
      .pipe(take(1))
      .subscribe(details => {
        this.agenciesList = details;
        this.qb.loading = false;
      });
  }

  searchAgencies(query: string) {
    this.qb.loading = true;
    this.searchQuery = query;
    this.debouncedGetAgencies(query);
  }

  copyToClipboard(text: string) {
    this.toast.clear();
    navigator.clipboard.writeText(text);
    this.toast.success('Copied "' + text + '" to clipboard');
  }
}
